import { Routes, Route } from "react-router-dom";
import { NotFoundScreen } from "screens/NotFoundScreen";
import DeliveryCreateScreen from "screens/App/CRM/ShipmentCompletion/DeliveryCreateScreen";
import DeliveryListScreen from "screens/App/CRM/ShipmentCompletion/DeliveryListScreen";
import DeliveryDetailScreen from "screens/App/CRM/ShipmentCompletion/DeliveryDetailScreen";
import DeliveryEditScreen from "screens/App/CRM/ShipmentCompletion/DeliveryEditScreen";
import DeliveryInfoScreen from "screens/App/CRM/ShipmentCompletion/DeliveryInfoScreen";
import BranchCollectCreateScreen from "screens/App/CRM/ShipmentCompletion/BranchCollectCreateScreen";

const DeliveryRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<DeliveryListScreen />} />
      <Route path="branch/delivery" element={<BranchCollectCreateScreen />} />
      <Route path="create" element={<DeliveryCreateScreen />} />
      <Route path=":id/detail" element={<DeliveryDetailScreen />} />
      <Route path=":id/edit" element={<DeliveryEditScreen />} />
      <Route path="info" element={<DeliveryInfoScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default DeliveryRouter;
